// extracted by mini-css-extract-plugin
export default {"grid":"ProductsEmpty_grid__AIGyW","button":"ProductsEmpty_button__VjD4T"};